import { prepareCommonShaftData, sendShaft } from "~/features/configurator/Shaft/api/sendShaftCommon";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import {
  prepareApiDataForResetNew,
  prepareGroupIdToDisplay,
} from "~/features/configurator/common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";

export function sendShaftDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonShaftData(linearState);
  const resetData = prepareApiDataForResetNew(linearState);

  prepareGroupIdToDisplay(data);

  return sendShaft({
    ...data,
    ...resetData,
  });
}
